import React from 'react';
import clsx from 'clsx';
import { Trans, useTranslation } from 'react-i18next';
import { getCurrentYear } from 'common-react';
import {
  CALC_LIMITS_TEST_ID,
  RETIREMENT_CALCULATOR_NAMESPACE,
} from '../../tools/RetirementCalculator.const';
import { RetirementCalculatorLimitsPropsModel } from '../../tools/RetirementCalculator.model';
import { useRetirementChartSeries } from '../../tools/useRetirementChartSeries';
import { RetirementCalculatorChartCard } from '../RetirementCalculatorChartCard/RetirementCalculatorChartCard';
import { RetirementCalculatorPromoCard } from '../RetirementCalculatorPromoCard/RetirementCalculatorPromoCard';

import useStyles from './RetirementCalculatorLimits.style';

export const RetirementCalculatorLimits: React.FC<RetirementCalculatorLimitsPropsModel> = ({
  projection,
  year = getCurrentYear(),
  className,
}) => {
  const c = useStyles({});
  const [t] = useTranslation(RETIREMENT_CALCULATOR_NAMESPACE, { useSuspense: false });
  const { series, scaleTicks } = useRetirementChartSeries(projection);

  return (
    <div className={clsx(c.root, className)}>
      <RetirementCalculatorPromoCard
        variant="compact"
        testId={`${CALC_LIMITS_TEST_ID}-promo`}
        badge={t('limits.badge', { year })}
        title={t('limits.title')}
        description={
          <Trans
            t={t}
            i18nKey="limits.description"
            components={{ accent: <strong /> }}
          />
        }
      />

      <RetirementCalculatorChartCard
        series={series}
        scaleTicks={scaleTicks}
        description={t('result.chart-description')}
        testId={`${CALC_LIMITS_TEST_ID}-chart`}
      />
    </div>
  );
};
